import { useCallback } from 'react';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { ErrorResponse } from '~/infra/ErrorResponse';
export function useCustomerDetail(clientId) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { FE_CRM } = useFeatureFlags();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.CustomerDetail,
            clientId
        ],
        queryFn: ()=>api.client.getById(clientId),
        enabled: enabled && FE_CRM === true && clientId !== '',
        refreshOnHookMount
    });
    const isNotFound = error != null && new ErrorResponse(error).hasStatus([
        404
    ]);
    const refreshWithoutThrowing = useCallback(()=>{
        void refresh({
            throwOnError: false
        });
    }, [
        refresh
    ]);
    return {
        clientDetails: data,
        isLoading,
        isError: error != null && !isNotFound,
        isNotFound,
        refresh: refreshWithoutThrowing
    };
}
